import React from "react";
import type { AppMode } from "../hooks/useTranslator";

interface HeaderLangSelectorsProps {
  appMode: AppMode;
  recording: boolean;
  srcLang: string;
  tgtLang: string;
  fromLabel: string;
  toLabel: string;
  minutaInLabel: string;
  setSrcLang: (lang: string) => void;
  setTgtLang: (lang: string) => void;
}

const selectStyle = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' fill='none'%3E%3Cpath d='M1 1l3 3 3-3' stroke='%23aaa' stroke-width='1.2' stroke-linecap='round'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat" as const,
  backgroundPosition: "right 7px center",
};

export const HeaderLangSelectors: React.FC<HeaderLangSelectorsProps> = ({
  appMode,
  recording,
  srcLang,
  tgtLang,
  fromLabel,
  toLabel,
  minutaInLabel,
  setSrcLang,
  setTgtLang,
}) => {
  if (appMode === "traductor") {
    return (
      <div className="flex items-center gap-[4px] flex-shrink-0">
        <span className="text-[10px] font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{fromLabel}</span>
        <select
          value={srcLang}
          onChange={(e) => setSrcLang(e.target.value)}
          disabled={recording}
          aria-label="Idioma de origen"
          className="font-sans text-[12px] font-[500] bg-[var(--surface-hover)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-[10px] pr-[24px] h-[27px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--sidebar-bg)] hover:border-[var(--border)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
          style={selectStyle}
        >
          <option value="auto">Auto-detectar (Multilingüe)</option>
          <option value="en">Inglés</option>
          <option value="es">Español</option>
        </select>
        <span className="text-[12px] text-[var(--text-dim)]">→</span>
        <span className="text-[10px] font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{toLabel}</span>
        <select
          value={tgtLang}
          onChange={(e) => setTgtLang(e.target.value)}
          disabled={recording}
          aria-label="Idioma de destino"
          className="font-sans text-[12px] font-[500] bg-[var(--surface-hover)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-[10px] pr-[24px] h-[27px] min-w-[100px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--sidebar-bg)] hover:border-[var(--border)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
          style={selectStyle}
        >
          <option value="es">Español</option>
          <option value="en">Inglés</option>
        </select>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-[4px] flex-shrink-0">
      <span className="text-[10.5px] font-[600] text-[var(--text-muted)] tracking-[0.02em] whitespace-nowrap">{minutaInLabel}</span>
      <select
        value={tgtLang}
        onChange={(e) => setTgtLang(e.target.value)}
        disabled={recording}
        aria-label="Idioma de la minuta"
        className="font-sans text-[12px] font-[500] bg-[var(--surface-hover)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-[10px] pr-[24px] h-[27px] min-w-[100px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--sidebar-bg)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={selectStyle}
      >
        <option value="es">Español</option>
        <option value="en">Inglés</option>
      </select>
    </div>
  );
};
